
import {  axiosInstance2, baseUrl2, handleErrors } from "./auth";

export const VENDOR_ADD_BANNER = async (params) => {
    try {
        const response = await axiosInstance2.post(`${baseUrl2}/vendor/addBanner`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
// Banner Edit 
export const VENDOR_EDIT_BANNER = async (params) => {
    try {
        const response = await axiosInstance2.put(`${baseUrl2}/vendor/updateBanner`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};

// Banner Delete 
export const VENDOR_DELETE_BANNER = async (params) => {
    try {
        const response = await axiosInstance2.post(`${baseUrl2}/vendor/deleteBanner`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
// Banner List 
export const VENDOR_BANNER_LIST = async (params) => {
    try {
        const response = await axiosInstance2.post(`${baseUrl2}/vendor/BannerList`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};

// Banner ID 
export const VENDOR_BANNER_ID = async (params) => {
    try {
        const response = await axiosInstance2.get(`${baseUrl2}/vendor/banner/:id`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
export const VENDOR_APPROVE_REQUEST = async (params) => {
    try {
        const response = await axiosInstance2.post(`${baseUrl2}/vendor/changeStatusBanner`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};